var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 131,
    viewBox: "0 0 163 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0069 109.04C115.129 109.04 137.927 86.24 137.927 58.02C137.927 29.8 115.028 7 87.0069 7C58.8859 7 36.0869 29.8 36.0869 58.02C36.0869 86.24 58.8859 109.04 87.0069 109.04Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.634 8.2334C98.2421 28.7134 82.9891 36.8634 69.0091 41.7334C65.7641 42.8734 62.2331 43.8734 58.8931 43.0134C55.5531 42.1634 52.6421 38.7733 53.5491 35.4333C54.3601 32.3333 58.3681 30.8035 61.2791 32.0435C64.2371 33.2835 65.8591 36.7233 65.5731 39.9133C65.2871 43.1133 63.3311 45.9233 60.8491 47.8833C58.3211 49.8433 55.3141 51.0333 52.2611 51.9333C45.5331 53.9433 38.5191 54.8933 31.9821 57.4233C25.3981 59.9533 19.1471 64.4833 16.9041 71.1133C15.2821 75.8433 15.9501 81.1833 18.0501 85.6633C20.1491 90.1533 23.7281 93.9233 27.7361 96.9233C33.8911 101.503 41.4771 104.363 49.1121 104.173C56.7461 103.983 64.4761 100.643 69.1991 94.6333C73.9231 88.6233 75.3071 79.8934 71.9671 72.9734C69.6771 68.2034 64.4761 64.2934 59.2751 65.4434C55.1711 66.3934 52.1651 70.4033 51.7361 74.6433C51.3061 78.8933 53.1671 83.0934 55.9351 86.2434C58.7021 89.4334 62.3761 91.6733 66.1931 93.6333C71.7761 96.4433 78.3611 98.5934 84.1341 96.2134C89.6211 93.9634 92.8181 88.2935 94.9171 82.8035C97.0171 77.3135 98.5911 71.3532 102.409 66.8232C106.989 61.3832 114.719 58.8534 121.638 60.4734C128.556 62.1034 134.377 67.8234 136.095 74.6934C137.431 80.0334 135.809 86.7135 130.799 89.0535C126.886 90.9135 122.067 89.5733 118.679 86.9033C115.292 84.2333 113.001 80.4234 110.806 76.6934",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3015 35.7931L29.9435 34.9931C30.1345 34.9431 30.1345 34.6629 29.9435 34.6029L27.3015 33.8132C27.2335 33.7932 27.1835 33.743 27.1655 33.673L26.3685 31.0331C26.3135 30.8431 26.0355 30.8431 25.9805 31.0331L25.1836 33.673C25.1656 33.743 25.1155 33.7932 25.0475 33.8132L22.4126 34.6029C22.2206 34.6629 22.2206 34.9431 22.4126 34.9931L25.0546 35.7931C25.1216 35.8131 25.1715 35.863 25.1895 35.923L25.9865 38.5729C26.0415 38.7629 26.3196 38.7629 26.3756 38.5729L27.1716 35.923C27.1836 35.863 27.2335 35.8131 27.3015 35.7931Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.557 4.86302L114.259 5.42308C114.453 5.47308 114.586 5.22299 114.444 5.08299L112.502 3.12303C112.451 3.07303 112.431 3.0131 112.447 2.9431L113.005 0.243146C113.047 0.0531457 112.803 -0.0867859 112.663 0.0632141L110.706 1.99315C110.657 2.04315 110.59 2.0632 110.522 2.0532L107.825 1.49315C107.63 1.45315 107.498 1.69299 107.64 1.83299L109.582 3.79319C109.633 3.84319 109.653 3.91314 109.636 3.98314L109.076 6.68309C109.034 6.87309 109.278 7.00302 109.418 6.86302L111.378 4.92308C111.421 4.87308 111.488 4.85302 111.557 4.86302Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.831 47.4525L148.482 46.9525C148.602 46.9225 148.602 46.7526 148.482 46.7126L146.831 46.2126C146.788 46.2026 146.758 46.1725 146.746 46.1325L146.248 44.4826C146.214 44.3626 146.04 44.3626 146.005 44.4826L145.508 46.1325C145.496 46.1725 145.465 46.2026 145.423 46.2126L143.775 46.7126C143.656 46.7526 143.656 46.9225 143.775 46.9525L145.426 47.4525C145.469 47.4625 145.5 47.4926 145.511 47.5426L146.009 49.1925C146.044 49.3125 146.217 49.3125 146.252 49.1925L146.75 47.5426C146.758 47.4926 146.788 47.4625 146.831 47.4525Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.397 24.5803C39.95 24.5803 41.209 23.3203 41.209 21.7603C41.209 20.2103 39.95 18.9502 38.397 18.9502C36.844 18.9502 35.584 20.2103 35.584 21.7603C35.584 23.3203 36.844 24.5803 38.397 24.5803Z",
    fill: "#F1F3F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5905_293879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7776 26.522L15.6991 28.2389C15.9621 28.7276 16.2039 29.0941 16.5885 29.4734C17.782 30.7724 19.5053 31.3769 21.2075 31.274C21.5084 31.2483 21.8126 31.3062 22.0299 31.4605C22.2826 31.5956 22.5379 31.8206 22.6884 32.0971C22.9893 32.6566 22.9379 33.3189 22.5797 33.8269C21.3663 35.4216 21.0023 37.5115 21.7161 39.4278C21.7939 39.6593 21.9071 39.8651 22.0383 40.1094L22.9597 41.8263C23.0729 42.0321 23.2208 42.2251 23.3147 42.3987L33.5957 36.8749C33.5365 36.682 33.4047 36.4312 33.3108 36.2576L32.3893 34.5472C32.2955 34.3735 32.1662 34.2128 32.0723 34.0391C32.035 33.9684 31.9437 33.8847 31.8871 33.7818C30.6673 32.1806 28.7774 31.3512 26.8277 31.4991C26.2251 31.5506 25.6284 31.1968 25.3274 30.6374C25.1956 30.393 25.1152 30.0715 25.1422 29.7885C25.1236 29.75 25.1583 29.7308 25.1583 29.7308C25.1853 29.4478 25.3204 29.1971 25.4548 28.9463C26.2753 27.8724 26.6984 26.5605 26.6753 25.178C26.6643 24.8243 26.654 24.4642 26.555 24.117C26.5524 24.027 26.4958 23.9176 26.4579 23.8532C26.3402 23.461 26.2033 23.0431 25.9962 22.6573L25.0747 20.9402C25.0561 20.9081 25.0188 20.8373 24.9808 20.7666L14.6298 26.3355C14.7217 26.4191 14.7403 26.4577 14.7776 26.522Z",
    fill: "url(#paint0_linear_5905_293879)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0287 28.8428L25.3724 26.7787L26.6592 25.229C26.6482 24.8753 26.6379 24.5216 26.5383 24.1679C26.5357 24.0779 26.4791 23.975 26.4418 23.9043C24.4034 24.0522 22.9752 24.4188 21.2126 26.6694C20.9219 27.0552 20.666 27.4153 20.3593 27.8525C17.7408 31.7815 21.0287 28.8428 21.0287 28.8428Z",
    fill: "#BAC3D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6083 29.506C17.8011 30.805 19.5245 31.4095 21.2266 31.3066C21.5282 31.2809 21.8317 31.3452 22.0497 31.4995L22.0844 31.4802C22.6439 31.178 23.3969 31.4031 23.6978 31.9625L26.4996 37.1711L27.5137 36.6246L24.6933 31.3837C24.3923 30.8242 24.5833 30.0911 25.1781 29.7696C25.2051 29.4867 25.3395 29.2295 25.4739 28.9787C26.2951 27.9048 26.7182 26.5995 26.6944 25.2105C26.6841 24.8569 26.6732 24.5031 26.5742 24.1494C24.7602 26.4772 22.8458 26.606 21.3019 26.6703C20.8234 26.7024 20.3797 26.7152 19.9547 26.7602C18.3091 26.9724 17.2732 27.982 16.6083 29.506Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0732 40.0899L22.9947 41.807C23.1073 42.0192 23.2552 42.2056 23.349 42.3792L32.5111 37.4535L33.1973 36.0516L32.3703 34.5083C32.2764 34.3347 32.1819 34.1611 32.0533 34.0068C32.0154 33.936 31.924 33.8461 31.8675 33.7432C31.8327 33.7625 31.8514 33.801 31.8166 33.8138C31.8006 33.8717 31.7652 33.8911 31.7305 33.9104C29.7094 36.4375 27.6285 36.341 25.9424 36.3924C25.6762 36.3989 25.3746 36.4247 25.127 36.4697C23.4654 36.7269 22.4134 37.7944 21.7318 39.3762C21.8636 39.6206 21.9414 39.8456 22.0732 40.0899Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3719 27.1974L25.8413 21.0243C26.0863 20.8956 26.1834 20.5741 26.0702 20.3619L25.469 19.243C25.3371 18.9987 25.0336 18.9343 24.7886 19.0694L13.2839 25.2554C13.0389 25.384 12.9232 25.6734 13.055 25.9177L13.6376 27.0046C13.8395 27.2104 14.1269 27.326 14.3719 27.1974Z",
    fill: "url(#paint1_linear_5905_293879)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2464 43.6971L34.7164 37.5302C34.9607 37.4016 35.0765 37.1122 34.9453 36.8679L34.362 35.7812C34.2309 35.5368 33.9267 35.4789 33.6817 35.6075L22.177 41.7937C21.9326 41.9287 21.8162 42.2115 21.948 42.4559L22.5313 43.5428C22.7326 43.7485 23.0014 43.8321 23.2464 43.6971Z",
    fill: "url(#paint2_linear_5905_293879)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5905_293879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 23.8704V92.2202C141 95.2102 138.578 97.6702 135.589 97.6702H37.4415C34.4515 97.6702 32 95.2402 32 92.2202V23.8704C32 20.8804 34.4215 18.4502 37.4415 18.4502H135.589C138.578 18.4502 141 20.8804 141 23.8704Z",
    fill: "url(#paint3_linear_5905_293879)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31C82 29.8954 81.1046 29 80 29H40C38.8954 29 38 29.8954 38 31V91C38 92.1046 38.8954 93 40 93H80C81.1046 93 82 92.1046 82 91V31Z",
    fill: "#D5DDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95 40H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95 75H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95 83H128",
    stroke: "#D6DCE8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24C32 20.6863 34.6863 18 38 18H135C138.314 18 141 20.6863 141 24V26H32V24Z",
    fill: "#D5DDEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.594 91.0617C152.168 92.8617 151.528 94.5917 150.746 96.1817C148.686 99.9117 145.63 102.952 141.793 104.822C137.813 106.822 133.123 107.512 128.362 106.612C117.276 104.332 110.099 93.8316 112.444 82.9816C114.789 72.1316 125.52 65.1517 136.676 67.4317C140.656 68.2617 144.138 70.1316 147.051 72.8216C151.883 77.6616 153.944 84.5017 152.594 91.0617Z",
    fill: "url(#paint4_linear_5905_293879)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.508 77.141L129.509 77.151L130.321 87.231C130.39 88.431 131.315 89.501 132.5 89.501C133.685 89.501 134.61 88.431 134.679 87.231L135.491 77.151L135.492 77.141C135.614 75.191 134.32 73.501 132.5 73.501C130.674 73.501 129.386 75.261 129.508 77.141Z",
    fill: "white",
    stroke: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 93.501C130.835 93.501 129.5 94.831 129.5 96.501C129.5 98.171 130.835 99.501 132.5 99.501C134.165 99.501 135.5 98.171 135.5 96.501C135.5 94.831 134.165 93.501 132.5 93.501Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5905_293879",
    x: 0.482903,
    y: 13.6931,
    width: 47.2598,
    height: 49.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.07349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07349
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5905_293879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5905_293879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5905_293879",
    x: 10,
    y: 7.4502,
    width: 153,
    height: 123.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5905_293879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5905_293879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5905_293879",
    x1: 19.6088,
    y1: 23.178,
    x2: 28.5517,
    y2: 39.8072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5905_293879",
    x1: 25.7757,
    y1: 19.8024,
    x2: 13.3534,
    y2: 26.4773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5905_293879",
    x1: 34.6598,
    y1: 36.3213,
    x2: 22.2374,
    y2: 43.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5905_293879",
    x1: 86.4645,
    y1: 16.6202,
    x2: 86.4645,
    y2: 98.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5905_293879",
    x1: 111.981,
    y1: 87.0016,
    x2: 153.007,
    y2: 87.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkInactive);
export default __webpack_public_path__ + "static/media/link_inactive.da5b54fd3c562800e406016102d40fc7.svg";
export { ForwardRef as ReactComponent };